export default [{
  name: 'stefanini',
  namespaced: true,
  state: {
    model: {
      selecionado: {},
      Cliente: {},
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      },
      PropostaDadosVeiculo: {},
      Desembolso: {
        Banco: {}
      },
      ObservacaoVendedor: '',
      ModeloComissao: null,
      Parcelas: null
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        selecionado: {},
        Cliente: {},
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaBanco: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {}
        },
        PropostaDadosVeiculo: {},
        Desembolso: {
          Banco: {}
        }
      }
      commit('model', data)
    }
  }
}]
